import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { pageQueryOptions } from "@modules/shopify/hooks";
import { getCountryVariables } from "@/modules/shared/localization/const/countries";
import { InfoPageBody } from "@modules/shop/components/InfoPage/InfoPageBody";

export const Route = createFileRoute(
  "/$locale/_layout/(public)/_public/info/about-us",
)({
  component: AboutUsPage,
  ssr: true,
  loader: async ({ context: { queryClient }, params }) => {
    const localeVars = getCountryVariables(params.locale);
    return queryClient.ensureQueryData(
      pageQueryOptions({ handle: "about-us", ...localeVars }),
    );
  },
  staleTime: 60_000 * 60, // 1 hour
  headers: () => ({
    "Cache-Control":
      "public, max-age=3600, s-maxage=3600, stale-while-revalidate=86400",
  }),
  head: ({ params, loaderData }) => {
    const t = i18n.getFixedT(params.locale);
    const page = loaderData?.page;
    return {
      meta: [
        ...seo({
          title: page?.seo?.title || t("Seo:aboutUs.title"),
          description: page?.seo?.description || t("Seo:aboutUs.description"),
          image: getFirstImageSrc(page?.body),
        }),
      ],
    };
  },
});

function AboutUsPage() {
  const { locale } = Route.useParams();
  return <InfoPageBody handle="about-us" locale={locale} />;
}

function getFirstImageSrc(html?: string | null) {
  if (!html) return undefined;

  const match = html.match(/<img\b[^>]*\bsrc=["']([^"']+)["']/i);
  return match?.[1];
}
